import { Box, Card, Typography, Paper } from "@mui/material";
import { observer } from "mobx-react";

interface SummaryCardProps {
  contentBackgroundColor: string;
  children: any;
  onLinkClicked: () => void;
}

const SummaryCard = observer(
  ({ children, onLinkClicked, contentBackgroundColor }: SummaryCardProps) => {
    return (
      <Card elevation={1}>
        <Box
          sx={{
            backgroundColor: contentBackgroundColor,
            flex: 1,
            paddingTop: 2,
            paddingLeft: 2,
            paddingRight: 2,
          }}
          className="flex-column-start-start"
        >
          {children}
        </Box>
        <Box className="flex-row-center-start" sx={{ padding: 2 }}>
          <Box
            sx={{ cursor: "pointer", padding: "2px" }}
            onClick={onLinkClicked}
          >
            <Typography sx={{ color: "#ff9700" }}>REGISTRERA / VISA</Typography>
          </Box>
        </Box>
      </Card>
    );
  }
);

export default SummaryCard;
